import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function PremiumIntro() {
  return <section className="relative overflow-hidden bg-mp-black py-20 md:py-28" data-id="element-204" data-mp="3pp3jimy1h0yo">
      <div className="pointer-events-none absolute inset-0 opacity-70" style={{
      background: 'radial-gradient(ellipse at 50% 0%, rgba(8,93,168,0.45), transparent 60%)'
    }} aria-hidden="true" data-id="element-205" data-mp="3um3vfehkkxxp" />
      <div className="pointer-events-none absolute bottom-0 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full opacity-30 blur-3xl" style={{
      background: 'rgba(216,240,0,0.4)'
    }} aria-hidden="true" data-id="element-206" data-mp="31yzmiyfcvzgn" />
      <Container className="relative z-10 text-center" data-id="element-207" data-mp="2e956y93njwsp">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} data-id="element-208" data-mp="2e8lzjmbmoqsx">
          <SectionTag tone="blue" data-id="element-209" data-mp="13km4pm3nwnh1">¿Quieres llevarlo un paso más allá?</SectionTag>
          <h2 className="mx-auto mt-5 max-w-[750px] font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-210" data-mp="zhzh5xe0xopn">
            Del conocimiento a la ejecución total.
          </h2>
          <div className="mx-auto mt-6 max-w-[650px] space-y-3 text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-211" data-mp="ppaadftf4z0n">
            <p data-id="element-212" data-mp="kpxey6ohejmg">Maestro en Pista te da el sistema.</p>
            <p data-id="element-213" data-mp="fsfdf1csn6oh">
              El Kit de Ejecución añade dos herramientas diseñadas para reducir todavía más el trabajo de convertir
              ese sistema en sesiones y temporadas organizadas.
            </p>
          </div>
        </motion.div>
      </Container>
    </section>;
}